import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { animated, useTransition } from 'react-spring';

import { selectResultScreenColor } from '../../store/selectors/init';

import styles from './Loader.module.scss';

interface IProps {
  isLoading: boolean;
  fullScreen?: boolean;
}

export default ({ isLoading = false, fullScreen = false }: IProps) => {
  const backgroundColor = useSelector(selectResultScreenColor);

  const [show, setShow] = useState(isLoading);

  useEffect(() => {
    setShow(isLoading);
  }, [isLoading]);

  const transitions = useTransition(show, null, {
    from: { position: 'absolute', opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  return (
    <React.Fragment>
      {transitions.map(
        ({ item, key, props }, i) =>
          item && (
            <div
              key={`loading-${i}`}
              data-testid="loader"
              className={cn(styles.loaderContainer, { [styles.fullScreen]: fullScreen })}
              style={{ backgroundColor }}
            >
              <animated.div className={styles.loader} key={key} style={props}>
                <div className={styles.dot} />
                <div className={styles.dot} />
                <div className={styles.dot} />
                <div className={styles.dot} />
                <div className={styles.dot} />
              </animated.div>
            </div>
          ),
      )}
    </React.Fragment>
  );
};
